import cc from './src/cc'
export default cc